import config from "../../config"
import RequestService from "../RequestService"

const createProject = (params, successCallback, failureCallback) => {
  RequestService.post(`${config.backendUrl}/projects`, { project: params }, successCallback, failureCallback)
}

export default createProject;